jQuery( document ).on('ready', function () {
  const menu = document.querySelectorAll( 'body' );
  const childrentrigger = document.querySelectorAll( '.menu-item-has-children' );
  const hamburger = document.querySelectorAll( '.nav-icon' );
  if(hamburger.length > 0){
    hamburger[0].addEventListener( 'click', function ( e ) {
      e.preventDefault();
      if(menu[0].classList.contains('menu-open')){
        menu[0].classList.remove('menu-open')
      }
      else{
        menu[0].classList.add('menu-open')
      }
    } );
    childrentrigger.forEach( function ( trigger ) {
      trigger.addEventListener( 'click', function ( e ) {
        
        if(this.classList.contains('menu-item-open')){
          this.classList.remove('menu-item-open')
        }
        else{
          childrentrigger.forEach( function ( item ) {
            item.classList.remove('menu-item-open')
          });
          this.classList.add('menu-item-open')
        }
      } );
    } );
    }
} );